import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dNullable from "../Data.Nullable/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dException from "../Effect.Exception/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dHoliday from "../Restaumatic.Holiday/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Utils$dDOM from "../Utils.DOM/index.js";
import * as Utils$dElm from "../Utils.Elm/index.js";
import * as Utils$dElm$dSpecular from "../Utils.Elm.Specular/index.js";
import * as Web$dDOM$dElement from "../Web.DOM.Element/index.js";
import * as Web$dDOM$dParentNode from "../Web.DOM.ParentNode/index.js";
import * as Web$dEvent$dEvent from "../Web.Event.Event/index.js";
import * as Web$dEvent$dEventTarget from "../Web.Event.EventTarget/index.js";
import * as Web$dHTML from "../Web.HTML/index.js";
import * as Web$dHTML$dWindow from "../Web.HTML.Window/index.js";
import * as Web$dInternal$dFFI from "../Web.Internal.FFI/index.js";
import {init, update} from "./foreign.js";
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Effect.applicativeEffect);
const for_1 = /* #__PURE__ */ for_(Data$dFoldable.foldableMaybe);
const for_2 = /* #__PURE__ */ for_(Data$dFoldable.foldableArray);
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dGeneric$dClass.readString};
const decode = /* #__PURE__ */ (() => Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
  reflectSymbol: () => "modifierClasses"
})(decodeWithOptionsOther)()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions))();
const foldMap = /* #__PURE__ */ (() => Data$dList$dTypes.foldableNonEmptyList.foldMap(Data$dMonoid.monoidString))();
const length = /* #__PURE__ */ Data$dFoldable.foldlArray(c => v => 1 + c | 0)(0);
const readString = /* #__PURE__ */ Foreign.unsafeReadTagged(Data$dIdentity.monadIdentity)("String");
const filterA = /* #__PURE__ */ Data$dArray.filterA(Effect.applicativeEffect);
const readInt = /* #__PURE__ */ Foreign.readInt(Data$dIdentity.monadIdentity);
const decodeWithOptionsOther1 = {decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode};
const decodeWithOptionsOther2 = {decodeWithOptions: v => Foreign$dGeneric$dClass.booleanDecode.decode};
const decode1 = /* #__PURE__ */ (() => Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
  reflectSymbol: () => "restaurantsAvailability"
})((() => {
  const decode2 = Foreign$dGeneric$dClass.arrayDecode({
    decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
      reflectSymbol: () => "upcomingHolidays"
    })((() => {
      const decode2 = Foreign$dGeneric$dClass.arrayDecode({
        decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
          reflectSymbol: () => "info"
        })(decodeWithOptionsOther)())({reflectSymbol: () => "duration"})(decodeWithOptionsOther)())({reflectSymbol: () => "description"})(decodeWithOptionsOther)()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
      }).decode;
      return {decodeWithOptions: v => decode2};
    })())())({reflectSymbol: () => "slug"})(decodeWithOptionsOther)())({reflectSymbol: () => "phoneHoursString"})(decodeWithOptionsOther)())({reflectSymbol: () => "phoneDayIndex"})(decodeWithOptionsOther1)())({
      reflectSymbol: () => "openingHoursString"
    })(decodeWithOptionsOther)())({reflectSymbol: () => "openingDayIndex"})(decodeWithOptionsOther1)())({reflectSymbol: () => "onlineHoursString"})(decodeWithOptionsOther)())({
      reflectSymbol: () => "onlineDayIndex"
    })(decodeWithOptionsOther1)())({reflectSymbol: () => "isRestaurantOpen"})(decodeWithOptionsOther2)())({reflectSymbol: () => "isPhonePossible"})(decodeWithOptionsOther2)())({
      reflectSymbol: () => "isOnlinePossible"
    })(decodeWithOptionsOther2)())({reflectSymbol: () => "holidaysInfo"})(decodeWithOptionsOther)())({reflectSymbol: () => "holidaysHoursString"})(decodeWithOptionsOther)()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
  }).decode;
  return {decodeWithOptions: v => decode2};
})())()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions))();
const safeView = element => state => dispatch => {
  const $0 = Utils$dElm.onInit(element)(() => {
    const $0 = Web$dHTML.window();
    const doc = Web$dHTML$dWindow.document($0)();
    const body = Web$dDOM$dParentNode.querySelector("body")(doc)();
    for_1(body)(body1 => {
      const $1 = Web$dEvent$dEventTarget.eventListener(ev => {
        const $1 = Data$dNullable.nullable(Web$dEvent$dEvent._target(ev), Data$dMaybe.Nothing, Data$dMaybe.Just);
        if ($1.tag === "Just") {
          const $2 = Utils$dDOM.ensureExistance("No event target found")(Web$dInternal$dFFI._unsafeReadProtoTagged(Data$dMaybe.Nothing, Data$dMaybe.Just, "Element", $1._1));
          return () => {
            const target = $2();
            const maybeTargetRoot = Utils$dDOM.closest(".js-restaurant-hours")(target)();
            const targetRoot = Utils$dDOM.ensureExistance("No parent of event target found")(maybeTargetRoot)();
            const presentDay = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-present-day")(targetRoot)();
            return for_1(presentDay)(presentDay1 => {
              const $3 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-header, .js-restaurant-hours-data, .js-restaurant-hours-btn-popover, .js-restaurant-hours-now")(presentDay1);
              return () => {
                const elementsToHide = $3();
                for_2(elementsToHide)(Utils$dDOM.addClass("u-visibility-hidden"))();
                const collapseBtn = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-btn-collapse")(presentDay1)();
                return for_1(collapseBtn)(collapseBtn1 => {
                  const $4 = Web$dDOM$dParentNode.querySelector(".js-icon-caret-up")(collapseBtn1);
                  return () => {
                    const caretUp = $4();
                    for_1(caretUp)(Utils$dDOM.show)();
                    const caretDown = Web$dDOM$dParentNode.querySelector(".js-icon-caret-down")(collapseBtn1)();
                    return for_1(caretDown)(Utils$dDOM.hide)();
                  };
                })();
              };
            })();
          };
        }
        const $2 = Utils$dDOM.ensureExistance("No event target found")(Data$dMaybe.Nothing);
        return () => {
          const target = $2();
          const maybeTargetRoot = Utils$dDOM.closest(".js-restaurant-hours")(target)();
          const targetRoot = Utils$dDOM.ensureExistance("No parent of event target found")(maybeTargetRoot)();
          const presentDay = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-present-day")(targetRoot)();
          return for_1(presentDay)(presentDay1 => {
            const $3 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-header, .js-restaurant-hours-data, .js-restaurant-hours-btn-popover, .js-restaurant-hours-now")(presentDay1);
            return () => {
              const elementsToHide = $3();
              for_2(elementsToHide)(Utils$dDOM.addClass("u-visibility-hidden"))();
              const collapseBtn = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-btn-collapse")(presentDay1)();
              return for_1(collapseBtn)(collapseBtn1 => {
                const $4 = Web$dDOM$dParentNode.querySelector(".js-icon-caret-up")(collapseBtn1);
                return () => {
                  const caretUp = $4();
                  for_1(caretUp)(Utils$dDOM.show)();
                  const caretDown = Web$dDOM$dParentNode.querySelector(".js-icon-caret-down")(collapseBtn1)();
                  return for_1(caretDown)(Utils$dDOM.hide)();
                };
              })();
            };
          })();
        };
      });
      return () => {
        const onShowListener = $1();
        Web$dEvent$dEventTarget.addEventListener("show.bs.collapse")(onShowListener)(true)(body1)();
        const onHideListener = Web$dEvent$dEventTarget.eventListener(ev => {
          const $2 = Data$dNullable.nullable(Web$dEvent$dEvent._target(ev), Data$dMaybe.Nothing, Data$dMaybe.Just);
          if ($2.tag === "Just") {
            const $3 = Utils$dDOM.ensureExistance("No event target found")(Web$dInternal$dFFI._unsafeReadProtoTagged(Data$dMaybe.Nothing, Data$dMaybe.Just, "Element", $2._1));
            return () => {
              const target = $3();
              const maybeTargetRoot = Utils$dDOM.closest(".js-restaurant-hours")(target)();
              const targetRoot = Utils$dDOM.ensureExistance("No parent of event target found")(maybeTargetRoot)();
              const presentDay = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-present-day")(targetRoot)();
              return for_1(presentDay)(presentDay1 => {
                const $4 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-header, .js-restaurant-hours-data, .js-restaurant-hours-btn-popover, .js-restaurant-hours-now")(presentDay1);
                return () => {
                  const elementsToShow = $4();
                  for_2(elementsToShow)(Utils$dDOM.removeClass("u-visibility-hidden"))();
                  const collapseBtn = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-btn-collapse")(presentDay1)();
                  return for_1(collapseBtn)(collapseBtn1 => {
                    const $5 = Web$dDOM$dParentNode.querySelector(".js-icon-caret-up")(collapseBtn1);
                    return () => {
                      const caretUp = $5();
                      for_1(caretUp)(Utils$dDOM.hide)();
                      const caretDown = Web$dDOM$dParentNode.querySelector(".js-icon-caret-down")(collapseBtn1)();
                      return for_1(caretDown)(Utils$dDOM.show)();
                    };
                  })();
                };
              })();
            };
          }
          const $3 = Utils$dDOM.ensureExistance("No event target found")(Data$dMaybe.Nothing);
          return () => {
            const target = $3();
            const maybeTargetRoot = Utils$dDOM.closest(".js-restaurant-hours")(target)();
            const targetRoot = Utils$dDOM.ensureExistance("No parent of event target found")(maybeTargetRoot)();
            const presentDay = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-present-day")(targetRoot)();
            return for_1(presentDay)(presentDay1 => {
              const $4 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-header, .js-restaurant-hours-data, .js-restaurant-hours-btn-popover, .js-restaurant-hours-now")(presentDay1);
              return () => {
                const elementsToShow = $4();
                for_2(elementsToShow)(Utils$dDOM.removeClass("u-visibility-hidden"))();
                const collapseBtn = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-btn-collapse")(presentDay1)();
                return for_1(collapseBtn)(collapseBtn1 => {
                  const $5 = Web$dDOM$dParentNode.querySelector(".js-icon-caret-up")(collapseBtn1);
                  return () => {
                    const caretUp = $5();
                    for_1(caretUp)(Utils$dDOM.hide)();
                    const caretDown = Web$dDOM$dParentNode.querySelector(".js-icon-caret-down")(collapseBtn1)();
                    return for_1(caretDown)(Utils$dDOM.show)();
                  };
                })();
              };
            })();
          };
        })();
        return Web$dEvent$dEventTarget.addEventListener("hide.bs.collapse")(onHideListener)(true)(body1)();
      };
    })();
    const slug = Web$dDOM$dElement.getAttribute("data-restaurant-slug")(element)();
    return Utils$dDOM.executeWhenLoaded(for_1(slug)(slug1 => dispatch({type: "GET_RESTAURANT_HOURS", payload: {slug: slug1}})))();
  });
  return () => {
    $0();
    const slug = Web$dDOM$dElement.getAttribute("data-restaurant-slug")(element)();
    return for_1(Data$dFoldable.find(Data$dFoldable.foldableArray)(x => {
      if (slug.tag === "Just") { return x.slug === slug._1; }
      return false;
    })(state.restaurantsAvailability))(av1 => {
      const $1 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-opening")(element);
      return () => {
        const children = $1();
        const shouldIncludeSelf = Utils$dDOM.hasClass("js-restaurant-hours-opening")(element)();
        const children$1 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-online")(element)();
        const shouldIncludeSelf$1 = Utils$dDOM.hasClass("js-restaurant-hours-online")(element)();
        for_1(Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, shouldIncludeSelf ? Data$dSemigroup.concatArray([element])(children) : children, 0))(a => {
          const $2 = av1.isRestaurantOpen;
          const $3 = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-is-active")(a);
          return () => {
            const isActive = $3();
            const isInactive = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-is-inactive")(a)();
            for_1(isActive)(isActive1 => for_1(isInactive)(isInactive1 => {
              if ($2) {
                const $4 = Utils$dDOM.show(isActive1);
                return () => {
                  $4();
                  return Utils$dDOM.hide(isInactive1)();
                };
              }
              const $4 = Utils$dDOM.hide(isActive1);
              return () => {
                $4();
                return Utils$dDOM.show(isInactive1)();
              };
            }))();
            const $4 = av1.isRestaurantOpen;
            const $5 = av1.openingHoursString;
            const classesData = Utils$dDOM.getData("active-classes")(a)();
            const v = readString(classesData);
            const activeClasses = (() => {
              if (v.tag === "Left") { return ""; }
              if (v.tag === "Right") { return v._1; }
              $runtime.fail();
            })();
            const classesData$1 = Utils$dDOM.getData("inactive-classes")(a)();
            const v$1 = readString(classesData$1);
            const inactiveClasses = (() => {
              if (v$1.tag === "Left") { return ""; }
              if (v$1.tag === "Right") { return v$1._1; }
              $runtime.fail();
            })();
            const children$2 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-present-day")(a)();
            const shouldIncludeSelf$2 = Utils$dDOM.hasClass("js-restaurant-hours-present-day")(a)();
            for_1(Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, shouldIncludeSelf$2 ? Data$dSemigroup.concatArray([a])(children$2) : children$2, 0))(presentDayWrapper1 => {
              const $6 = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-data")(presentDayWrapper1);
              return () => {
                const presentDayData = $6();
                for_1(presentDayData)(Utils$dDOM.setInnerHtml($5))();
                if ($4) {
                  Utils$dDOM.addClass(activeClasses)(presentDayWrapper1)();
                  return Utils$dDOM.removeClass(inactiveClasses)(presentDayWrapper1)();
                }
                Utils$dDOM.addClass(inactiveClasses)(presentDayWrapper1)();
                return Utils$dDOM.removeClass(activeClasses)(presentDayWrapper1)();
              };
            })();
            const children$3 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-all-days")(a)();
            const shouldIncludeSelf$3 = Utils$dDOM.hasClass("js-restaurant-hours-all-days")(a)();
            for_1(Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, shouldIncludeSelf$3 ? Data$dSemigroup.concatArray([a])(children$3) : children$3, 0))(wrapper => {
              const $6 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-day")(wrapper);
              return () => {
                const days = $6();
                return for_2(days)(day => {
                  const $7 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-btn-popover, .js-restaurant-hours-now")(day);
                  return () => {
                    const otherDaysEls = $7();
                    return for_2(otherDaysEls)(Utils$dDOM.hide)();
                  };
                })();
              };
            })();
            const $6 = av1.isRestaurantOpen;
            const $7 = av1.openingDayIndex;
            const classesData$2 = Utils$dDOM.getData("active-classes")(a)();
            const v$2 = readString(classesData$2);
            const activeClasses$1 = (() => {
              if (v$2.tag === "Left") { return ""; }
              if (v$2.tag === "Right") { return v$2._1; }
              $runtime.fail();
            })();
            const classesData$3 = Utils$dDOM.getData("inactive-classes")(a)();
            const v$3 = readString(classesData$3);
            const inactiveClasses$1 = (() => {
              if (v$3.tag === "Left") { return ""; }
              if (v$3.tag === "Right") { return v$3._1; }
              $runtime.fail();
            })();
            const children$4 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-all-days")(a)();
            const shouldIncludeSelf$4 = Utils$dDOM.hasClass("js-restaurant-hours-all-days")(a)();
            for_1(Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, shouldIncludeSelf$4 ? Data$dSemigroup.concatArray([a])(children$4) : children$4, 0))(wrapper => {
              const $8 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-day")(wrapper);
              return () => {
                const days = $8();
                const a$p = filterA(x => {
                  const $9 = Utils$dDOM.getData("day")(x);
                  return () => {
                    const day = $9();
                    const v$4 = readInt(day);
                    if (v$4.tag === "Left") { return false; }
                    if (v$4.tag === "Right") { return v$4._1 === $7; }
                    $runtime.fail();
                  };
                })(days)();
                return for_1(Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, a$p, 0))(today => {
                  const $9 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-btn-popover, .js-restaurant-hours-now")(today);
                  return () => {
                    const todayElems = $9();
                    for_2(todayElems)(Utils$dDOM.show)();
                    if ($6) {
                      Utils$dDOM.addClass(activeClasses$1)(today)();
                      return Utils$dDOM.removeClass(inactiveClasses$1)(today)();
                    }
                    Utils$dDOM.addClass(inactiveClasses$1)(today)();
                    return Utils$dDOM.removeClass(activeClasses$1)(today)();
                  };
                })();
              };
            })();
            const popover = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-popover")(a)();
            const title = av1.isRestaurantOpen
              ? Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.hours.open), {})
              : Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.hours.closed), {});
            const info = av1.holidaysInfo;
            const desc = av1.holidaysHoursString === ""
              ? ""
              : Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.hours.holidays), {}) + ": " + av1.holidaysHoursString;
            return for_1(popover)(popover1 => {
              const $8 = av1.isRestaurantOpen;
              const $9 = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-popover-title")(popover1);
              return () => {
                const popoverTitle = $9();
                for_1(popoverTitle)(Utils$dDOM.setInnerHtml(title))();
                const popoverDetails = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-popover-details")(popover1)();
                for_1(popoverDetails)(Utils$dDOM.setInnerHtml(desc))();
                const popoverInfo = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-popover-info")(popover1)();
                for_1(popoverInfo)(Utils$dDOM.setInnerHtml(info))();
                return for_2(Data$dArray.mapMaybe(x => x)([popoverTitle, popoverDetails, popoverInfo]))(x => {
                  if ($8) {
                    const $10 = Utils$dDOM.addClass("text-success")(x);
                    return () => {
                      $10();
                      return Utils$dDOM.removeClass("text-danger")(x)();
                    };
                  }
                  const $10 = Utils$dDOM.addClass("text-danger")(x);
                  return () => {
                    $10();
                    return Utils$dDOM.removeClass("text-success")(x)();
                  };
                })();
              };
            })();
          };
        })();
        for_1(Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, shouldIncludeSelf$1 ? Data$dSemigroup.concatArray([element])(children$1) : children$1, 0))(a => {
          const $2 = av1.isOnlinePossible;
          const $3 = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-is-active")(a);
          return () => {
            const isActive = $3();
            const isInactive = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-is-inactive")(a)();
            for_1(isActive)(isActive1 => for_1(isInactive)(isInactive1 => {
              if ($2) {
                const $4 = Utils$dDOM.show(isActive1);
                return () => {
                  $4();
                  return Utils$dDOM.hide(isInactive1)();
                };
              }
              const $4 = Utils$dDOM.hide(isActive1);
              return () => {
                $4();
                return Utils$dDOM.show(isInactive1)();
              };
            }))();
            const $4 = av1.isOnlinePossible;
            const $5 = av1.onlineHoursString;
            const classesData = Utils$dDOM.getData("active-classes")(a)();
            const v = readString(classesData);
            const activeClasses = (() => {
              if (v.tag === "Left") { return ""; }
              if (v.tag === "Right") { return v._1; }
              $runtime.fail();
            })();
            const classesData$1 = Utils$dDOM.getData("inactive-classes")(a)();
            const v$1 = readString(classesData$1);
            const inactiveClasses = (() => {
              if (v$1.tag === "Left") { return ""; }
              if (v$1.tag === "Right") { return v$1._1; }
              $runtime.fail();
            })();
            const children$2 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-present-day")(a)();
            const shouldIncludeSelf$2 = Utils$dDOM.hasClass("js-restaurant-hours-present-day")(a)();
            for_1(Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, shouldIncludeSelf$2 ? Data$dSemigroup.concatArray([a])(children$2) : children$2, 0))(presentDayWrapper1 => {
              const $6 = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-data")(presentDayWrapper1);
              return () => {
                const presentDayData = $6();
                for_1(presentDayData)(Utils$dDOM.setInnerHtml($5))();
                if ($4) {
                  Utils$dDOM.addClass(activeClasses)(presentDayWrapper1)();
                  return Utils$dDOM.removeClass(inactiveClasses)(presentDayWrapper1)();
                }
                Utils$dDOM.addClass(inactiveClasses)(presentDayWrapper1)();
                return Utils$dDOM.removeClass(activeClasses)(presentDayWrapper1)();
              };
            })();
            const children$3 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-all-days")(a)();
            const shouldIncludeSelf$3 = Utils$dDOM.hasClass("js-restaurant-hours-all-days")(a)();
            for_1(Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, shouldIncludeSelf$3 ? Data$dSemigroup.concatArray([a])(children$3) : children$3, 0))(wrapper => {
              const $6 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-day")(wrapper);
              return () => {
                const days = $6();
                return for_2(days)(day => {
                  const $7 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-btn-popover, .js-restaurant-hours-now")(day);
                  return () => {
                    const otherDaysEls = $7();
                    return for_2(otherDaysEls)(Utils$dDOM.hide)();
                  };
                })();
              };
            })();
            const $6 = av1.isOnlinePossible;
            const $7 = av1.onlineDayIndex;
            const classesData$2 = Utils$dDOM.getData("active-classes")(a)();
            const v$2 = readString(classesData$2);
            const activeClasses$1 = (() => {
              if (v$2.tag === "Left") { return ""; }
              if (v$2.tag === "Right") { return v$2._1; }
              $runtime.fail();
            })();
            const classesData$3 = Utils$dDOM.getData("inactive-classes")(a)();
            const v$3 = readString(classesData$3);
            const inactiveClasses$1 = (() => {
              if (v$3.tag === "Left") { return ""; }
              if (v$3.tag === "Right") { return v$3._1; }
              $runtime.fail();
            })();
            const children$4 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-all-days")(a)();
            const shouldIncludeSelf$4 = Utils$dDOM.hasClass("js-restaurant-hours-all-days")(a)();
            for_1(Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, shouldIncludeSelf$4 ? Data$dSemigroup.concatArray([a])(children$4) : children$4, 0))(wrapper => {
              const $8 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-day")(wrapper);
              return () => {
                const days = $8();
                const a$p = filterA(x => {
                  const $9 = Utils$dDOM.getData("day")(x);
                  return () => {
                    const day = $9();
                    const v$4 = readInt(day);
                    if (v$4.tag === "Left") { return false; }
                    if (v$4.tag === "Right") { return v$4._1 === $7; }
                    $runtime.fail();
                  };
                })(days)();
                return for_1(Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, a$p, 0))(today => {
                  const $9 = Utils$dDOM.querySelectorAll$p(".js-restaurant-hours-btn-popover, .js-restaurant-hours-now")(today);
                  return () => {
                    const todayElems = $9();
                    for_2(todayElems)(Utils$dDOM.show)();
                    if ($6) {
                      Utils$dDOM.addClass(activeClasses$1)(today)();
                      return Utils$dDOM.removeClass(inactiveClasses$1)(today)();
                    }
                    Utils$dDOM.addClass(inactiveClasses$1)(today)();
                    return Utils$dDOM.removeClass(activeClasses$1)(today)();
                  };
                })();
              };
            })();
            const popover = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-popover")(a)();
            const title = av1.isOnlinePossible
              ? Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.hours.active), {})
              : Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.hours.inactive), {});
            const info = av1.holidaysInfo;
            const desc = av1.holidaysHoursString === ""
              ? ""
              : Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.hours.holidays), {}) + ": " + av1.holidaysHoursString;
            return for_1(popover)(popover1 => {
              const $8 = av1.isOnlinePossible;
              const $9 = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-popover-title")(popover1);
              return () => {
                const popoverTitle = $9();
                for_1(popoverTitle)(Utils$dDOM.setInnerHtml(title))();
                const popoverDetails = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-popover-details")(popover1)();
                for_1(popoverDetails)(Utils$dDOM.setInnerHtml(desc))();
                const popoverInfo = Web$dDOM$dParentNode.querySelector(".js-restaurant-hours-popover-info")(popover1)();
                for_1(popoverInfo)(Utils$dDOM.setInnerHtml(info))();
                return for_2(Data$dArray.mapMaybe(x => x)([popoverTitle, popoverDetails, popoverInfo]))(x => {
                  if ($8) {
                    const $10 = Utils$dDOM.addClass("text-success")(x);
                    return () => {
                      $10();
                      return Utils$dDOM.removeClass("text-danger")(x)();
                    };
                  }
                  const $10 = Utils$dDOM.addClass("text-danger")(x);
                  return () => {
                    $10();
                    return Utils$dDOM.removeClass("text-success")(x)();
                  };
                })();
              };
            })();
          };
        })();
        const $2 = av1.upcomingHolidays;
        const content = Web$dDOM$dParentNode.querySelector(".js-upcoming-holidays-content")(element)();
        return for_1(content)(content1 => {
          const $3 = Utils$dDOM.parents(".js-upcoming-holidays-wrapper")(content1);
          return () => {
            const a$p = $3();
            return for_1(Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, a$p, 0))(wrapper1 => {
              const $4 = Utils$dDOM.getData("widget-config")(wrapper1);
              return () => {
                const holidayConfig = $4();
                const v = decode(holidayConfig);
                const config = (() => {
                  if (v.tag === "Left") {
                    Utils$dDOM.logErrorOnElement("Element doesn't have the property data-widget-config set correctly, current value: " + holidayConfig + "Errors: " + foldMap(Foreign.renderForeignError)(v._1))(wrapper1)();
                    return {modifierClasses: ""};
                  }
                  if (v.tag === "Right") { return v._1; }
                  $runtime.fail();
                })();
                if (length($2) === 0) { return Utils$dDOM.hide(wrapper1)(); }
                Utils$dDOM.show(wrapper1)();
                return Utils$dElm$dSpecular.specularView(Restaumatic$dHoliday.widget(config))(content1)($2)(dispatch)();
              };
            })();
          };
        })();
      };
    })();
  };
};
const view = element => fstate => dispatch => {
  const v = decode1(fstate);
  if (v.tag === "Right") { return safeView(element)(v._1)(dispatch); }
  if (v.tag === "Left") {
    return Effect$dException.throwException(Effect$dException.error("Incorrect data passed to RestaurantHours view, Errors: " + foldMap(Foreign.renderForeignError)(v._1)));
  }
  $runtime.fail();
};
export {
  decode,
  decode1,
  decodeWithOptionsOther,
  decodeWithOptionsOther1,
  decodeWithOptionsOther2,
  filterA,
  foldMap,
  for_,
  for_1,
  for_2,
  length,
  readInt,
  readString,
  safeView,
  view
};
export * from "./foreign.js";
